__turbopack_context__.v({
  "manageContainer": "portfolioTabs-module-scss-module__dLV9xG__manageContainer",
  "manageIcon": "portfolioTabs-module-scss-module__dLV9xG__manageIcon",
  "selectedTab": "portfolioTabs-module-scss-module__dLV9xG__selectedTab",
  "tab": "portfolioTabs-module-scss-module__dLV9xG__tab",
  "tabContent": "portfolioTabs-module-scss-module__dLV9xG__tabContent",
  "tabs": "portfolioTabs-module-scss-module__dLV9xG__tabs",
  "verticalLine": "portfolioTabs-module-scss-module__dLV9xG__verticalLine",
  "wrapper": "portfolioTabs-module-scss-module__dLV9xG__wrapper",
});
